import { createSlice } from '@reduxjs/toolkit';
import { ForgotPasswordTypeProps } from './types';

export const initialState: ForgotPasswordTypeProps = {
  fetching: false,
  loginError: false,
};

export const forgotPassword = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getForgotPasswordRequest(state, _action) {
      state.fetching = true;
      state.loginError = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getForgotPasswordSuccess(state, action) {
      state.fetching = false;
      state.loginError = false;
    },
    getForgotPasswordError(state, action) {
      state.fetching = false;
      state.loginError = action.payload;
    },
  },
  extraReducers: {},
});

export const { actions } = forgotPassword;

export default forgotPassword.reducer;
